import classNames from "classnames/bind";
import React from "react";

import UIIcon from "common/blocks/UIIcon";
import styles from "./MenuHeader.module.scss";

const cx = classNames.bind(styles);

type Props = {
    handleBackStepView: () => void;
    title: string;
};

export const MenuHeader = React.forwardRef<HTMLDivElement, Props>(
    ({ handleBackStepView, title = "" }, ref) => {
        return (
            <div className={cx("header")} ref={ref}>
                <div data-testid="chevronLeftWrapper" onClick={() => handleBackStepView()}>
                    <UIIcon className={styles.chevronLeft} icon="ChevronLeft" />
                </div>
                <div className={cx("headerTitleWrapper")}>
                    <h4 className={cx("headerTitle")}>{title}</h4>
                    <div className={cx("headerTitleRhomb")} />
                </div>
            </div>
        );
    }
);

MenuHeader.displayName = "MenuHeader";
